import { NotFoundPage } from '@lingoda/fallbacks';
import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';
import {
    Route,
    type RouteConfigComponentProps,
    type RouteConfigExtended,
    type RouteConfigOption,
    Switch,
    TabValue,
    renderRoutes,
    studentPracticeGrammarTrainerPath,
    studentPracticeLessonMaterialsPath,
    studentPracticeLingobitesPath,
    studentPracticeLingobotPath,
    studentPracticePath,
    studentPracticeVocabularyPath,
    studentPracticeWritingExamPrepPath,
} from '@lingoda/router';
import { LinearProgress, Suspense } from '@lingoda/ui';
import { PracticePage as LegacyPracticePage } from '../pages/Practice/lazy';
import { PracticeDashboardPage } from './PracticeDashboardPage/lazy';
import { VocabularyDashboardPage } from './VocabularyDashboardPage/lazy';
import { LingobotDashboardPage } from './LingobotDashboardPage/lazy';
import { LingobitesDashboardPage } from './LingobitesDashboardPage/lazy';
import { LessonMaterialsDashboardPage } from './LessonMaterialsDashboardPage/lazy';
import { GrammarTrainerDashboardPage } from './GrammarTrainerDashboardPage/lazy';
import { WritingExamPrepDashboardPage } from './WritingExamPrepDashboardPage/lazy';

const PracticeDashboardRoutes = (props: RouteConfigComponentProps) => {
    const feature = useFeatureFlagValue(KameleoonFlagKey.practicePageRevamp);

    if (feature.isLoading) {
        return <LinearProgress />;
    }

    if (!feature.isVariant) {
        return (
            <Switch>
                <Route exact path={studentPracticePath.raw} component={LegacyPracticePage} />
                <Route component={NotFoundPage} />
            </Switch>
        );
    }

    return <Suspense variant="linear">{renderRoutes(props.route?.routes)}</Suspense>;
};

const GrammarTrainerDashboardRoute = () => {
    const feature = useFeatureFlagValue(KameleoonFlagKey.grammarTrainer);

    if (feature.isLoading) {
        return <LinearProgress />;
    }

    if (!feature.isVariant) {
        return <NotFoundPage />;
    }

    return <GrammarTrainerDashboardPage />;
};

const WritingExamPrepDashboardRoute = () => {
    const feature = useFeatureFlagValue(KameleoonFlagKey.writingExamPrep);

    if (feature.isLoading) {
        return <LinearProgress />;
    }

    if (!feature.isVariant) {
        return <NotFoundPage />;
    }

    return <WritingExamPrepDashboardPage />;
};

const dashboardConfig: RouteConfigOption = {
    tab: TabValue.Practice,
};

export const practiceDashboardRoutes: RouteConfigExtended[] = [
    {
        component: PracticeDashboardRoutes,
        path: studentPracticePath.raw,
        label: 'Practice',
        config: dashboardConfig,
        routes: [
            {
                exact: true,
                component: PracticeDashboardPage,
                path: studentPracticePath.raw,
                label: 'Practice',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: VocabularyDashboardPage,
                path: studentPracticeVocabularyPath.raw,
                label: 'Practice Vocabulary',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: LingobotDashboardPage,
                path: studentPracticeLingobotPath.raw,
                label: 'Practice Lingobot',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: LingobitesDashboardPage,
                path: studentPracticeLingobitesPath.raw,
                label: 'Practice Lingobites',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: GrammarTrainerDashboardRoute,
                path: studentPracticeGrammarTrainerPath.raw,
                label: 'Practice Grammar Trainer',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: LessonMaterialsDashboardPage,
                path: studentPracticeLessonMaterialsPath.raw,
                label: 'Practice Lesson Materials',
                config: dashboardConfig,
            },
            {
                exact: true,
                component: WritingExamPrepDashboardRoute,
                path: studentPracticeWritingExamPrepPath.raw,
                label: 'Practice Writing Exam Prep',
                config: dashboardConfig,
            },
        ],
    },
];
